// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkedIn: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 44 40" enableBackground="new 0 0 44 40" xmlSpace="preserve">
<g fill="currentColor">
	<path d="M33.12,12.56c-4.92,0-7.99,2.66-8.56,4.53v-4.27h-9.63c0.03,0.61,0.05,2.85,0.05,5.81l0,0.72c0,0.12,0,0.25,0,0.37l0,2.74
		c0,1.08,0,2.2,0,3.32l0,1.26c-0.01,6.03-0.04,11.86-0.05,12.81l0,0.13h9.63V25.3c0-0.82-0.04-1.64,0.21-2.22
		c0.66-1.63,2.08-3.33,4.64-3.33c3.35,0,4.87,2.51,4.87,6.19V40H44V24.89C44,16.47,39.21,12.56,33.12,12.56z"/>
	<rect x="1.11" y="12.83" width="8.58" height="27.17"/>
	<path d="M5.24,0C2.07,0,0,2.03,0,4.72c0,2.63,2.01,4.71,5.12,4.71h0.06c3.22,0,5.23-2.08,5.23-4.72C10.35,2.03,8.4,0,5.24,0z"/>
</g>
</svg>;
};

export default React.memo(LinkedIn);
